import { parseDataSource } from "./expressions.js";
export default function convertList(_ref) {
  var properties = _ref.properties;
  var props = properties;
  var dataSource = props.dataSource,
    fields = props.fields,
    variant = props.variant;
  var parsedDataSource = parseDataSource(dataSource);
  return {
    brick: "eo-list",
    properties: {
      variant: variant,
      dataSource: parsedDataSource.isString ? parsedDataSource.embedded : dataSource,
      fields: fields,
      themeVariant: "elevo"
    }
  };
}
//# sourceMappingURL=convertList.js.map